import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SigningSession from './signing-session';
import SigningSessionDetail from './signing-session-detail';
import SigningSessionUpdate from './signing-session-update';
import SigningSessionDeleteDialog from './signing-session-delete-dialog';

const SigningSessionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SigningSession />} />
    <Route path="new" element={<SigningSessionUpdate />} />
    <Route path=":id">
      <Route index element={<SigningSessionDetail />} />
      <Route path="edit" element={<SigningSessionUpdate />} />
      <Route path="delete" element={<SigningSessionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SigningSessionRoutes;
